module.exports = __webpack_public_path__ + "media/images/pie/escu_raya-42ef6c3ea42c1382d1830fc3314f5a2a.png";